import * as types from '../constants/ActionTypes';
import { SOCKET_UNESTABLISHED } from '../constants/SocketStatus';

const initialState = {
  status: SOCKET_UNESTABLISHED,
  maximumReconnectsReached: false,
};

const socket = (state = initialState, action) => {
  switch (action.type) {
    case types.SOCKET_CONNECTING:
    case types.SOCKET_CONNECT_SUCCESS:
    case types.SOCKET_CONNECT_FAIL:
      return { ...state, status: action.payload.status };
    case types.MAXIMUM_SOCKET_RECONNECT_ATTEMPTS_REACHED:
      return { ...state, maximumReconnectsReached: action.payload.maximumReconnectsReached };
    default:
      return state;
  }
};

export default socket;
